import { EmpresasService } from './../../../services/empresas/empresas.service';
import { LineaAdquirenteService } from './../../../services/operaciones/linea-adquirente/linea-adquirente.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Component, EventEmitter, Output, OnDestroy, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import Swal from 'sweetalert2';
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesStatus, MessagesTitles } from 'app/models/messages';
import { Observable, Subscription } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { LineaAdquirente } from 'app/models/LineaAdquirente.model';
import { environment } from '../../../../environments/environment';

export enum ESTADO_LINEA {
  REGISTRADO = 'R',
  EN_EVALUACION = 'P',
  EVALUADO = 'E',
  BLOQUEADO = 'X',
  DESBLOQUEADO = 'D',
  BAJA = 'B'
}

export enum ESTADO_EMPRESA {
  ACTIVO = 'A',
  BLOQUEADO = 'X',
  BAJA = 'B'
}

@Component({
  selector: 'app-nueva-linea',
  templateUrl: './nueva-linea.component.html',
  styleUrls: ['./nueva-linea.component.scss'],
  providers: [MessagesTitles, MessagesStatus]
})
export class NuevaLineaComponent implements OnInit, OnDestroy {
  @Input() lineaAdquirente: LineaAdquirente;
  @Output() cerrarDetalleLinea: EventEmitter<boolean>;
  @Output() refresh = new EventEmitter<boolean>();
  @ViewChild('searchInput', { static: false }) searchInput: ElementRef;

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Id_Confirming=environment.ID_CONFIRMING;
  Id_Factoring=environment.ID_FACTORING;
  titulo: string = 'Crear nueva línea de '+this.Label_Adquirente.toLowerCase();
  monedaElement: number = this.Label_id_soles;
  estadoEmpresa: string = '';
  empresaSeleccionada: any;
  tipoServicioElement: number = this.Id_Factoring;
  save: boolean = false;
  isRiesgo: boolean = false;
  loading: boolean = false;
  adqui: boolean = false;
  idAdquirente: string = "";
  rucAdquirenteSearch: FormControl = new FormControl();
  formCrearLineaAdq: FormGroup;
  formEvaluacionLineaAdq: FormGroup;
  formAdjuntos: FormGroup;
  subLista: Subscription = new Subscription();
  filteredAdquirentes: Observable<any[]>;
  adquirentesArr: any[] = [];
  arrayAdjuntos: any[] = [];
  files: any[] = [];
  adjuntosTemp: any[] = [];
  dataEnviar: any = {};
  dataEmpresa: any = [];
  user: any;
  filesB64: any;
  cantItems: number;
  IP: string = '192.168.1.1';
  readonly ROLE_ADMIN: number = environment.ROLE_ADMIN_ID;
  readonly ROLE_RIESGO: number = environment.ROLE_RIESGO_ID; // Rol Riesgo desde bd SecurityDBDev
  readonly NRO_ADJUNTOS_MINIMOS: number = 1; // Nro de adjuntos de este módulo = 10 (8 distintos y 2 repetidos)
  readonly NOMBRE_MODULO: string = 'lineaAdquirente';
  readonly CODIGO_ADJUNTOS: string = '2';
  readonly CANAL: string = 'W';

  constructor(
    private msgStatus: MessagesStatus,
    private msgTitulos: MessagesTitles,
    private fb: FormBuilder,
    private lineaAdquirenteService: LineaAdquirenteService,
    private empresasService: EmpresasService
  ) {
    this.cerrarDetalleLinea = new EventEmitter();
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.IP = JSON.parse(sessionStorage.getItem('PUBLIC-IP')).ip;
    this.isRiesgo = this.userHasValidRole([this.ROLE_ADMIN, this.ROLE_RIESGO]);
    this.armarFormularios();
  }

  userHasValidRole(id_roles: number[]) {
    return id_roles.includes(this.user.id_roles);
  }

  armarFormularios() {
    this.formCrearLineaAdq = this.fb.group({
      idEmpresa: ['', [Validators.required]],
      Num_Doc_Identificacion: ['', [Validators.required]],
      Moneda: 2,
      TipoServicio: this.Id_Factoring,
      FlgAval: false,
      Alta_Usuario: this.user.Usuario,
      LineaAdmitida: 0.00,
      Comentarios: '',
      FlgNuevo: true
    });

    this.formEvaluacionLineaAdq = this.fb.group({
      idLineaAdquirente: '',
      Modificacion_Usuario: '',
      LineaAdmitida: '',
      TipoServicio: '',
      Moneda: '',
      Comentarios: '',
      ModificacionCanal: this.CANAL,
      IP: this.IP
    });

    this.formAdjuntos = this.fb.group({
      idEmpresa: new FormControl({ value: "", disabled: true }),
      idContacto: new FormControl({ value: "", disabled: true }),
      TipoAdjunto: new FormControl({ value: "", disabled: true }),
      file_content: new FormControl({ disabled: true }),
      Usuario: new FormControl({ value: "", disabled: true }),
      Razon_Social: new FormControl({ value: "", disabled: true }),
      Num_Doc_Identificacion: new FormControl({ value: "", disabled: true }),
      file_empresa: new FormControl({ value: "", disabled: false }),
      Estado: new FormControl({ value: "", disabled: true }),
    });
  }

  ngOnInit() {
    if (this.lineaAdquirente != null) {
      this.titulo = 'Línea de '+this.Label_Adquirente.toLowerCase()+' N° '.concat(this.lineaAdquirente.idLineaAdquirente.toString());
      this.formCrearLineaAdq.patchValue({
        idEmpresa: this.lineaAdquirente.idEmpresa,
        Num_Doc_Identificacion: this.lineaAdquirente.Num_Doc_Identificacion,
        Moneda: this.lineaAdquirente.Moneda,
        FlgAval: (this.lineaAdquirente.FlgAval == 1) ? true : false,
        LineaAdmitida: this.lineaAdquirente.LineaAdmitida,
        TipoServicio: this.lineaAdquirente.TipoServicio,
        Comentarios: this.lineaAdquirente.Comentarios,
        FlgNuevo: false
      });

      this.monedaElement = this.lineaAdquirente.Moneda;
      this.tipoServicioElement = this.lineaAdquirente.TipoServicio;

      if (this.isRiesgo) {
        this.formCrearLineaAdq.get('LineaAdmitida').setValidators([Validators.required, Validators.min(0.01), Validators.max(999999999.99)]);
        this.formCrearLineaAdq.get('Comentarios').setValidators([Validators.required]);
      }

      this.dataEmpresa.idEmpresa = this.lineaAdquirente.idEmpresa;

      this.formEvaluacionLineaAdq.patchValue({
        idLineaAdquirente: this.lineaAdquirente.idLineaAdquirente,
        Modificacion_Usuario: this.user.Usuario
      });

      if (this.lineaAdquirente.Estado == ESTADO_LINEA.EN_EVALUACION || this.lineaAdquirente.Estado == ESTADO_LINEA.EVALUADO || this.lineaAdquirente.Estado == ESTADO_LINEA.DESBLOQUEADO) {
        this.formCrearLineaAdq.get('TipoServicio').disable();
        this.formCrearLineaAdq.get('Moneda').disable();
        this.formCrearLineaAdq.get('FlgAval').disable();
      }

      this.obtenerAdjuntos(this.formCrearLineaAdq.get('idEmpresa').value, false);
    } else {
      this.obtenerAdquirentesCombo();
    }
  }

  ngOnDestroy() {
    this.subLista.unsubscribe();
    this.formCrearLineaAdq.reset();
    this.formAdjuntos.reset();
  }

  tipoMoneda(event) {
    this.formCrearLineaAdq.controls['Moneda'].setValue(event);
    if (this.rucAdquirenteSearch.value != '' && this.formCrearLineaAdq.get('idEmpresa').value != '') {
      this.validarExistenciaLineaAdqu();
    }
  }

  tipoServicio(event) {
    this.formCrearLineaAdq.controls['TipoServicio'].setValue(event);
    if (this.rucAdquirenteSearch.value != '' && this.formCrearLineaAdq.get('idEmpresa').value != '') {
      this.validarExistenciaLineaAdqu();
    }
  }

  limpiarAdq() {
    this.formCrearLineaAdq.get('Ruc_Adquirente').setValue('');
    this.arrayAdjuntos = [];
  }

  private _filterAdq(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.adquirentesArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true ||
        state.Num_Doc_Identificacion.toLowerCase().includes(filterValue) === true
    );
  }

  obtenerAdjuntos(idEmpresa: any, validarAdquirente: boolean) {
    Swal.fire({
      title: "Espere",
      text: "Obteniendo adjuntos...",
      type: "info",
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();

    this.loading = true;
    let sub: Subscription;
    sub = this.empresasService.obtenerAdjuntosEmpresa(idEmpresa).subscribe(
      (resp: any[]) => {
        this.loading = false;
        this.arrayAdjuntos = resp.filter(adjunto => adjunto.Origen === this.NOMBRE_MODULO);
        if (validarAdquirente) {
          this.validarExistenciaLineaAdqu();
        } else {
          Swal.close();
        }
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
          this.msgStatus.getMessage(err.status);
        } else {
          this.msgStatus.getMessage(err.status);
        }

        Swal.fire({
          title: this.msgTitulos.Error,
          text: "ADJUNTOS NO OBTENIDOS. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        }).then((result) => {
          if (result.value) {
            this.validarExistenciaLineaAdqu();
          }
        });
      });

    this.subLista.add(sub);
  }

  obtenerAdquirentesCombo() {
    this.estadoEmpresa = 'Cargando lista de '+this.Label_Adquirentes.toLowerCase()+'..';
    this.rucAdquirenteSearch.disable();
    let sub: Subscription;
    this.loading = true;
    sub = this.empresasService.obtenerAdquirente().subscribe(
      (res: any) => {
        this.rucAdquirenteSearch.enable();
        this.estadoEmpresa = 'Buscar el '+this.Label_Adquirente.toLowerCase()+' para ver su estado';
        this.loading = false;
        this.adquirentesArr = res;
        this.filteredAdquirentes = this.rucAdquirenteSearch.valueChanges
          .pipe(
            startWith(''),
            map(state =>
              state ? this._filterAdq(state) : this.adquirentesArr.slice()
            )
          );
      },
      () => {
        this.rucAdquirenteSearch.enable();
        this.estadoEmpresa = 'Buscar el '+this.Label_Adquirente.toLowerCase()+' para ver su estado';
        this.adquirentesArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
      }
    );

    this.subLista.add(sub);
  }

  obtenerRucRazSocialAdq(termino: any) {
    if (termino != null && termino != '') {
      let terminoLC = termino.toLowerCase();
      for (let a of this.adquirentesArr) {
        let raz = a.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(terminoLC) >= 0) {
          this.idAdquirente = a.Num_Doc_Identificacion;
        }
      }
    }
  }

  obtenerRucAdq(termino: any) {
    this.idAdquirente = termino.idEmpresa;
    this.formCrearLineaAdq.get('Num_Doc_Identificacion').setValue(termino.Num_Doc_Identificacion);
    this.formCrearLineaAdq.get('idEmpresa').setValue(this.idAdquirente);
    this.empresaSeleccionada = termino;
    if (this.empresaSeleccionada.Estado == ESTADO_EMPRESA.ACTIVO) {
      this.estadoEmpresa = '¡El '+this.Label_Adquirente.toLowerCase()+' seleccionado se encuentra activo!';
    } else if (this.empresaSeleccionada.Estado == ESTADO_EMPRESA.BAJA) {
      this.estadoEmpresa = '¡El '+this.Label_Adquirente.toLowerCase()+' seleccionado se encuentra de baja!';
    } else if (this.empresaSeleccionada.Estado == ESTADO_EMPRESA.BLOQUEADO) {
      this.estadoEmpresa = '¡El '+this.Label_Adquirente.toLowerCase()+' seleccionado se encuentra bloqueado!';
    }

    this.searchInput.nativeElement.blur();
    this.obtenerAdjuntos(this.idAdquirente, true);
  }

  validarExistenciaLineaAdqu() {
    this.loading = true;
    let listAdqu: LineaAdquirente[] = JSON.parse(sessionStorage.getItem('adqArr'));
    let idEmpresa: number = this.formCrearLineaAdq.get('idEmpresa').value;
    let tipoServicio: number = this.formCrearLineaAdq.get('TipoServicio').value;
    let moneda: number = this.formCrearLineaAdq.get('Moneda').value;
    let itemFound: LineaAdquirente = listAdqu.find(linea => linea.idEmpresa == idEmpresa && linea.TipoServicio == tipoServicio && linea.Moneda == moneda);
    if (itemFound != undefined && this.empresaSeleccionada.Estado == ESTADO_EMPRESA.ACTIVO) {
      this.loading = false;
      let text: string = `La línea del `+this.Label_Adquirente.toLowerCase()+` <br/><strong>${this.empresaSeleccionada.Razon_Social.toUpperCase()}</strong>, <br/> 
      con tipo de servicio <strong>${itemFound.TipoServicioDsc.toUpperCase()}</strong> y moneda <strong>${itemFound.MonedaDsc.toUpperCase()}</strong> ya existe.<br/>
      ¿Solicitar una nueva línea de `+this.Label_Adquirente.toLowerCase()+`? <br/>`;
      Swal.fire({
        title: "Atención",
        html: text,
        type: "question",
        showCancelButton: true,
        confirmButtonText: 'Si, continuar',
        cancelButtonText: 'No, cancelar',
        reverseButtons: true,
        allowOutsideClick: false,
        heightAuto: false
      }).then((result) => {
        if (result.value) {
          this.formCrearLineaAdq.get('FlgAval').setValue(itemFound.FlgAval == 1 ? true : false);
          this.formCrearLineaAdq.get('FlgNuevo').setValue(false);
        }
      });
    } else {
      this.loading = false;
      let text: string = `No existe ninguna línea para el `+this.Label_Adquirente.toLowerCase()+` <br/><strong>${this.empresaSeleccionada.Razon_Social.toUpperCase()}</strong><br/> 
      con el tipo de servicio y la moneda indicados.`;
      Swal.fire({
        title: "Atención",
        html: text,
        type: "info",
        confirmButtonText: 'Ok, continuar',
        allowOutsideClick: false,
        heightAuto: false
      }).then((result) => {
        if (result.value) {
          this.formCrearLineaAdq.get('FlgNuevo').setValue(true);
        }
      });
    }
  }

  clearValuesInputSearch() {
    this.rucAdquirenteSearch.setValue('');
    this.idAdquirente = '';
    this.empresaSeleccionada = null;
    this.estadoEmpresa = 'Buscar el '+this.Label_Adquirente.toLowerCase()+' para ver su estado';
  }

  tipoAdjunto(event: any, i: number) {
    if (this.files[i].type != 'application/pdf') {
      Swal.fire({
        title: this.msgTitulos.Error,
        text: '¡El archivo ' + this.files[i].name + ' no es PDF!',
        type: "warning",
        allowOutsideClick: false,
        heightAuto: false
      });

      this.deleteFile(i);
    } else {
      this.files[i].Tipo_Adjunto = event;
      this.buscarAdjuntosRepetidos(this.files[i], this.adjuntosTemp);
    }
  }

  buscarAdjuntosRepetidos(file: any, arrayAdjuntosTemp: any[]) {
    let index: number = arrayAdjuntosTemp.findIndex(item => item === file);
    if (index == -1) arrayAdjuntosTemp.push(file);
  }

  onFileDropped($event: any) {
    this.prepareFilesList($event);
  }

  fileBrowseHandler(files: any) {
    this.prepareFilesList(files);
  }

  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }

    this.uploadFilesSimulator(0);
  }

  deleteFile(index: number) {
    this.files.splice(index, 1);
    this.adjuntosTemp.splice(index, 1);
  }

  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 20);
      }
    }, 100);
  }

  formatBytes(bytes: any, decimals: any) {
    if (bytes === 0) {
      return '0 Bytes';
    }

    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  guardarAdjuntos(idAdquirente: number) {
    this.cantItems = this.files.length - 1;
    this.dataEnviar.idEmpresa = idAdquirente;
    this.dataEnviar.Usuario = this.user.Usuario;
    this.dataEnviar.Alta_Canal = this.CANAL;
    this.dataEnviar.Archivos = [];

    let i = 0;
    for (let p of this.files) {
      if (p.Tipo_Adjunto == undefined) {
        Swal.fire({
          title: this.msgTitulos.Error,
          text: 'Seleccione tipo de documento adjunto',
          type: "warning",
          allowOutsideClick: false,
          heightAuto: false
        });
        return;
      }

      this.aBinario(this.files, i);
      i++;
    }
  }

  aBinario(fileList: any, index: any) {
    let file = fileList[index];
    let fileReader: FileReader = new FileReader();
    var base64;
    var archivo64;
    var self = this;
    fileReader.onload = function (fileLoadedEvent) {
      base64 = fileLoadedEvent.target['result'];
      archivo64 = base64.split(',', 2);
      self.filesB64 = archivo64[1];
      self.dataEnviar.Archivos.push(
        {
          'file_type': file.type,
          'file_name': file.name,
          'file_content': self.filesB64,
          'Tipo_Adjunto': file.Tipo_Adjunto,
          'Origen': self.NOMBRE_MODULO
        }
      );

      if (self.cantItems == index) {
        self.enviarAdjuntos(self.dataEnviar);
      }
    };

    fileReader.readAsDataURL(file);
  }

  enviarAdjuntos(dataEnviar: any) {
    Swal.fire({
      title: "Espere",
      text: "Guardando Archivos...",
      type: "info",
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();

    let sub: Subscription;
    sub = this.empresasService.agregarAdjuntoDinamico(dataEnviar).subscribe(
      () => {
        Swal.fire({
          title: "Success",
          text: "¡Archivos registrados correctamente!",
          type: "success",
          allowOutsideClick: false,
          heightAuto: false
        }).then(resp => {
          if (resp.value) {
            if (this.save) {
              this.refresh.emit();
              this.cerrarPopUp();
            } else {
              this.obtenerAdjuntos(this.formCrearLineaAdq.get('idEmpresa').value, false);
              this.files = [];
              this.adjuntosTemp = [];
            }
          }
        });
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
          this.msgStatus.getMessage(err.status);
        } else {
          this.msgStatus.getMessage(err.status);
        }

        Swal.fire({
          title: this.msgTitulos.Error,
          text: "ARCHIVO NO GUARDADO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );

    this.subLista.add(sub);
  }

  darBajaAdjuntoDinamico(idAdjunto: number) {
    Swal.fire({
      title: '',
      text: '¿Estás seguro en dar de baja el adjunto?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, dar de baja.',
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: '¡Espere!',
          html: 'Procesando...'
        });
        Swal.showLoading();

        this.formAdjuntos = new FormGroup({
          'idAdjunto': new FormControl(idAdjunto),
          'Estado': new FormControl('B'),
          'Usuario': new FormControl(this.user.Usuario)
        });

        let sub: Subscription;
        sub = this.empresasService.bajaAdjuntoDinamico(this.formAdjuntos.getRawValue()).subscribe(
          () => {
            Swal.fire({
              title: 'Adjunto dado de baja',
              text: '¡El adjunto fue dado de baja exitosamente!',
              type: 'success',
              heightAuto: false
            }).then(resp => {
              if (resp.value) {
                this.obtenerAdjuntos(this.formCrearLineaAdq.get('idEmpresa').value, false);
              }
            });
          },
          () => {
            Swal.fire({
              title: "Error",
              text: "No se pudo dar de baja el adjunto.",
              type: "error",
              allowOutsideClick: false,
              heightAuto: false
            });
          }
        );

        this.subLista.add(sub);
      }
    });
  }

  isBtnCrearDisabled() {
    return (this.loading || !this.formCrearLineaAdq.valid || this.empresaSeleccionada.Estado == ESTADO_EMPRESA.BLOQUEADO ||
      this.empresaSeleccionada.Estado == ESTADO_EMPRESA.BAJA);
  }

  crearLineaAdquirente() {
    if (this.adjuntosTemp.length < this.NRO_ADJUNTOS_MINIMOS) {
      Swal.fire({
        title: "Atención",
        text: "Verificar la cantidad de adjuntos de la línea nueva.",
        type: "warning",
        allowOutsideClick: false,
        heightAuto: false
      });
      return false;
    }

    if (this.empresaSeleccionada.Estado == ESTADO_EMPRESA.BLOQUEADO || this.empresaSeleccionada.Estado == ESTADO_EMPRESA.BAJA) {
      Swal.fire({
        title: "Atención",
        text: "Verificar el estado de la empresa seleccionada.",
        type: "warning",
        allowOutsideClick: false,
        heightAuto: false
      });
      return false;
    }

    let flagAval = this.formCrearLineaAdq.get('FlgAval').value;
    if (typeof flagAval == 'boolean' && !flagAval) {
      this.formCrearLineaAdq.get('FlgAval').setValue(0);
    } else {
      this.formCrearLineaAdq.get('FlgAval').setValue(1);
    }

    Swal.fire({
      title: "Espere",
      text: "Registrando línea nueva...",
      type: "info",
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();

    let sub: Subscription;
    sub = this.lineaAdquirenteService.crearLineaAdquirente(this.formCrearLineaAdq.getRawValue()).subscribe(
      () => {
        this.save = true;
        this.guardarAdjuntos(this.formCrearLineaAdq.get('idEmpresa').value);
      },
      (errRegistro: HttpErrorResponse) => {
        this.loading = false;
        this.msgStatus.getMessage(errRegistro.status);

        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Línea no creada. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    );

    this.subLista.add(sub);
  }

  isBtnEvaluarDisabled() {
    return this.loading || !this.formCrearLineaAdq.valid || !this.isRiesgo;
  }

  evaluarLineaAdquirente() {
    this.formEvaluacionLineaAdq.patchValue({
      Alta_Usuario: this.user.Usuario,
      LineaAdmitida: this.formCrearLineaAdq.get('LineaAdmitida').value,
      TipoServicio: this.lineaAdquirente.TipoServicio,
      Moneda: this.lineaAdquirente.Moneda,
      Comentarios: this.formCrearLineaAdq.get('Comentarios').value
    });

    Swal.fire({
      title: "Espere",
      text: "Evaluando línea...",
      type: "info",
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();

    let sub: Subscription;
    this.loading = true;
    sub = this.lineaAdquirenteService.evaluarLineaAdquirente(this.lineaAdquirente.idLineaAdquirente, this.formEvaluacionLineaAdq.getRawValue()).subscribe(
      () => {
        this.loading = false;
        this.refresh.emit();
        this.cerrarPopUp();
        Swal.fire({
          title: "Success",
          text: "¡Línea evaluada correctamente!",
          type: "success",
          allowOutsideClick: false,
          heightAuto: false
        }).then(resp => {
          if (resp.value) {
            this.save = true;
          }
        });
      },
      (errEval: HttpErrorResponse) => {
        this.loading = false;
        this.msgStatus.getMessage(errEval.status);

        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Línea no evaluada. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    );

    this.subLista.add(sub);
  }

  cerrarPopUp() {
    this.formCrearLineaAdq.reset();
    this.formAdjuntos.reset();
    this.cerrarDetalleLinea.emit();
  }
}